import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import type * as React from 'react'
import { useContext, useEffect, useState } from 'react'
import type { ConversationInfo } from '../interfaces/ConversationIf'
import { LanguageContext } from '../util/LanguageContext'
import { detectTextDirection } from '../util/TextDirection'

type AnonymousConversationListProps = {
  date: string | undefined
  items: ConversationInfo[] | undefined
  id?: string
}

export const AnonymousConversationList: React.FC<AnonymousConversationListProps> = ({
  date,
  items,
  id,
}) => {
  // スマホ用vh
  const [vh, setVh] = useState(window.innerHeight * 0.01)
  // 文字列変換用
  const translation = useContext(LanguageContext)

  useEffect(() => {
    const handleResize = () => setVh(window.innerHeight * 0.01)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ textAlign: 'center', borderBottom: '2px solid #282828' }}>
                {date}
                {id ? (
                  <Box sx={{ fontSize: '18px' }}>
                    <Box>{translation['label_conversation_ID']}</Box>
                    <Box>{id}</Box>
                  </Box>
                ) : null}
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
      <TableContainer
        style={{
          // maxHeight: `calc(${vh * 100}px - 112px -58px - 77px)`,
          maxHeight: `calc(${vh * 100}px - 245px)`,
          overflowY: 'auto',
        }}
      >
        <Table>
          <TableBody>
            {items?.map(
              row =>
                row.edit_text !== '' &&
                (row.original_text ? (
                  // 会話が違う言語で行われている場合
                  <TableRow key={row.conversation_id}>
                    <TableCell align={row.speaker === 1 ? 'left' : 'right'}>
                      <div
                        style={{
                          font: 'normal normal normal 18px Noto Sans JP',
                          direction: detectTextDirection(
                            row.edit_text ? row.edit_text : row.org_text,
                          ),
                        }}
                      >
                        {row.edit_text ? row.edit_text : row.org_text}
                      </div>
                      <div
                        style={{
                          font: 'normal normal normal 12px Noto Sans JP',
                          marginTop: '10px',
                          direction: detectTextDirection(row.original_text),
                        }}
                      >
                        {row.original_text}
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  // 会話が同じ言語で行われている場合
                  <TableRow key={row.conversation_id}>
                    <TableCell align={row.speaker === 1 ? 'left' : 'right'}>
                      <div
                        style={{
                          font: 'normal normal normal 12px Noto Sans JP',
                        }}
                      >
                        {row.edit_text ? row.edit_text : row.org_text}
                      </div>
                    </TableCell>
                  </TableRow>
                )),
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
